import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Row from './Row';

const Container = ({ items, parentId, parentIndex }) => (
  <div
    className={classNames('new-ticket__wrapper', {
      'new-ticket__wrapper-categories': parentId === null,
    })}
    data-parent-id={parentId}
  >
    {items?.map((item, index) => (
      <Row
        key={`ticket-row-${index}`}
        parentIndex={item.item === 0 ? index : parentIndex}
        index={index}
        collection={item.collection}
        item={item}
      />
    ))}
  </div>
);

Container.propTypes = {
  items: PropTypes.array,
  parentId: PropTypes.string,
  parentIndex: PropTypes.number,
};

export default SortableContainer(Container);
